export const sizing = {
    padding: {
        xs: '2px',
        s: '5px',
        m: '10px',
        l: '15px',
        xl: '30px',
        xxl: '60px',
    },
    margin: {
        xs: '2px',
        s: '5px',
        m: '10px',
        l: '15px',
        xl: '30px',
        xxl: '60px',
    },
}
